import { NgModule } from '@angular/core';
import { WorkplaceAppModule } from '@app/app.module';
import { AppComponent } from '@app/app.component';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { CUSTOMERENVIRONMENT, WINDOW } from '@app/common/app-tokens';
import { BaseTrackingService } from '@app/tracking/base-tracking.service';
import { AppInsightsService } from '@app/tracking/app-insights.service';

@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    WorkplaceAppModule.forRoot(),
    RouterModule.forRoot(environment.routeConfig),
  ],
  providers: [
    { provide: CUSTOMERENVIRONMENT, useValue: environment },
    { provide: BaseTrackingService, useClass: AppInsightsService },
    { provide: WINDOW, useValue: window }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
